import { useCallback } from 'react'
import { collection, serverTimestamp } from 'firebase/firestore'
import { addDoc } from '../lib/firestore'
import { db } from '../lib/firebase'
import { runMutation } from '../lib/firestoreMutation'
import { track } from '../lib/analytics'
import { fbt } from 'fbtee'

export type RequestRegionSource = 'region_picker'

// Requests are triaged from the admin queue, which is the only thing that ever
// updates them — rules reject any client write past the create.
export function useRegionRequests(userId: string | null) {
  const requestRegion = useCallback(
    async (text: string, entryPoint: RequestRegionSource) => {
      if (!userId) return
      await runMutation(
        fbt('Could not send your request', 'Error toast when submitting a region request fails'),
        async () => {
          await addDoc(collection(db, 'regionRequests'), {
            text: text.trim(),
            submittedBy: userId,
            createdAt: serverTimestamp(),
            status: 'pending',
          })
          track('region_requested', { entry_point: entryPoint })
        },
      )
    },
    [userId],
  )

  return { requestRegion }
}
